import React from 'react';

export const WaveDivider = ({ className, ...props }) => (
  <svg className={className} width="103" height="12" viewBox="0 0 103 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path stroke="#5246F5" strokeWidth="5" strokeLinecap="round" d="M2.5 5.54199C6.28543 1.48617 12.7146 1.48617 16.5 5.54199C20.2854 9.59781 26.7146 9.59781 30.5 5.54199C34.2854 1.48617 40.7146 1.48617 44.5 5.54199C48.2854 9.59781 54.7146 9.59781 58.5 5.54199C62.2854 1.48617 68.7146 1.48617 72.5 5.54199C76.2854 9.59781 82.7146 9.59781 86.5 5.54199C90.2854 1.48617 96.7146 1.48617 100.5 5.54199" />
  </svg>
);
